export default "__VITE_ASSET__CQeLt$co__"